// const API_BASE_URL = "http://localhost:5000";
const API_BASE_URL = "https://vcapmoney.sits.work";

export default API_BASE_URL;
